import React, { Component } from 'react';
import { Button, DatePicker } from 'antd';
import SelectProvince from '../../common/SelectProvince';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import API_URL from '../../../common/url';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = this.props;
        const { userName } = searchParams;
        this.state = {
            searchParams,
            isEdit: !!userName,
            render: true,
        }
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({...searchParams});
    }

    export = () => {
        this.props.export();
    }

    reset = () => {
        const { searchParams: { defaultMonth } } = this.state;
        this.setState({
            render: false,
            searchParams: {
                defaultMonth,
                inspectionTime: defaultMonth,
                endDate: defaultMonth,
            }
        }, () => {
            this.setState({ render: true }, () => {
                this.search();
            })
        })
    }

    handleDateChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        searchParams[key] = dateString
        this.setState({ searchParams });
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    disabledDate = (current) => {
        const { maxDate } = this.props;
        const value = moment(maxDate).add(1, 'M').valueOf();
        return current && current.valueOf() >= value;
    }

    handleChange = (option, key) => {
        const { searchParams } = this.state;
        const { text, value } = option;
        searchParams.leaderUserId = value;
        searchParams.leaderUserName = text;
        this.setState({ searchParams });
    }

    render () {
        const {
            render,
            searchParams: {
                inspectionTime,
                areaName,
                leaderUserName,
                hasCheckedArea = [],
            }
        } = this.state;
        const newInspectionTime = inspectionTime ? moment(inspectionTime) : null;
        const { positionRole } = sessionStorage;
        return (
            <div className="filter-bar bar2" style={{ marginTop: 10 }}>
                <div className="form-item">
                    <label className="ui-label">转正月份</label>
                    <MonthPicker
                        format={monthFormat}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'inspectionTime')}
                        allowClear={false}
                        value={newInspectionTime}
                        style={{width: 90}}
                        disabledDate={this.disabledDate}
                        className="w-90-select"
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">团队领导</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 162 }}
                        value={leaderUserName}
                        params={{ limit: 20 }}
                        placeholder="输入姓名/工号检索"
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={option => this.handleChange(option, 'leaderUserId')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">区域/城市</label>
                    { render && <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} /> }
                </div>
                <div className="form-item">
                    {/* <Button type="primary" onClick={this.reset}>重置</Button> */}
                    { positionRole !== 'CRC' && <Button type="primary" onClick={this.export}>导出</Button> }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/home/teamRecommendTalentRank/Filter.js